import { EXPERIENCES, HOME_URL, SOCIAL_LINKS } from "../../config/lumacofono";

const LOGO = "/brand/lumacofono-logo-128.jpg";

const FooterColumn = ({ title, links, testid }) => (
  <div>
    <h3 className="text-[12px] font-bold uppercase tracking-[0.08em] text-[#B6C5D9] mb-2">{title}</h3>
    <nav className="grid gap-0.5" aria-label={title}>
      {links.map((l) => (
        <a
          key={l.id}
          href={l.href}
          {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          data-testid={`${testid}-${l.id}`}
          className="text-[14px] text-[#E0E8F3] py-1.5 hover:text-white transition-colors"
        >
          {l.label}
          {l.external && " ↗"}
        </a>
      ))}
    </nav>
  </div>
);

const SOCIALS = SOCIAL_LINKS.map((s) => ({ ...s, external: true }));

export const LumacofonoFooter = () => (
  <footer className="relative z-10 mt-14 bg-[#17243D] text-white rounded-t-[28px]" data-testid="lumacofono-footer">
    <div className="max-w-6xl mx-auto px-5 pt-8 pb-6">
      <div className="grid gap-7 sm:grid-cols-[1.2fr_1fr_1fr]">
        <a href={HOME_URL} className="flex items-center gap-3 self-start" data-testid="footer-brand">
          <span className="bg-white rounded-[12px] p-1 flex">
            <img src={LOGO} alt="Logo Lumacofono" width="48" height="48" className="w-12 h-12 object-contain" />
          </span>
          <span className="luma-wordmark text-[22px] text-white">Lumacofono</span>
        </a>
        <div className="grid grid-cols-2 gap-6 sm:contents">
          <FooterColumn title="Esplora" links={EXPERIENCES} testid="footer-exp" />
          <FooterColumn title="Podcast e social" links={SOCIALS} testid="footer-link" />
        </div>
      </div>
      <div className="mt-6 pt-4 border-t border-white/15 text-[12px] leading-relaxed text-[#B6C5D9]">
        <p data-testid="fan-disclaimer">
          Progetto fan-made non ufficiale dedicato a One Piece. Non affiliato né approvato da Eiichiro Oda, Shueisha o
          Toei Animation. One Piece e i relativi personaggi e nomi appartengono ai rispettivi titolari.
        </p>
        <p className="mt-2 font-semibold text-[#E0E8F3]" data-testid="footer-copyright">© Lumacofono</p>
      </div>
    </div>
  </footer>
);
